import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { getContactInfo, getPayment } from "../../store/contact/contactAction";
import { useEffect } from "react";
import { baseUrl } from "../../utils/APi";
import logo from "../../assets/logo1.png";
const Footer = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const lan = useSelector((state) => state.LanSlicer.language);

  return (
    <>
      <footer id="footer" className="clearfix">
        <div id="footer-top" className="container">
          <div className="row">
            <div className="col-md-8">
              <span className="section-title-page  font-weight-500">
                Let’s Make Something Together Start a
              </span>
              <span className="link-style-3 text-under section-title-page font-weight-500 margin-left-10">
                <a href="contact.html">conversation</a>
              </span>
            </div>
            <div className="col-md-4">
              <a
                href="contact.html"
                className="button-footer arrow-btn btn-st .style-3"
              >
                Hire Me Now
              </a>
            </div>
          </div>
        </div>
        <div id="footer-widgets" className="container-fluid px-md-5 px-2 ">
          <div className="row ">
            <div className="col-md-5">
              <div className="logo-footer margin-bottom-20">
                <a href="index.html" rel="home" className="main-logo">
                  <img src={logo} alt="images" />
                </a>
              </div>
              <p className=" line-height-32 margin-bottom-20">
                We’re a group of creative nerds who enjoy doing something we
                love every day. Etiam efficitur, metus in cursus imperdiet,
                neque nisl porta erat, nec volutpat felis lacus a tellus.
              </p>
              <div className="widget-subcribe">
                <form
                  action="#"
                  method="get"
                  className="subcribe-form margin-right-100"
                >
                  <input
                    type="email"
                    className="subcribe-form-footer"
                    placeholder="Enter e-mail"
                    value=""
                    name="s"
                    required
                  />
                  <button
                    className="btn-subcribe-footer"
                    type="submit"
                    title="subcribe"
                  ></button>
                </form>
              </div>
            </div>
            <div className="col-md-7">
              <div className="footer-widgets-nav-menu text-white">
                <div className="menu-1">
                  <h3 className="widget-title-link-wrap">SERVICES</h3>
                  <ul className="link-wrap">
                    <li>
                      <a href="services.html">Strategy</a>
                    </li>
                    <li>
                      <a href="services.html">Design</a>
                    </li>
                    <li>
                      <a href="services.html">Content</a>
                    </li>
                    <li>
                      <a href="services.html">Technology</a>
                    </li>
                  </ul>
                </div>
                <div className="menu-2">
                  <h3 className="widget-title-link-wrap">OTHER</h3>
                  <ul className="link-wrap">
                    <li>
                      <a href="about.html">About Us</a>
                    </li>
                    <li>
                      <a href="portfolio.html">Portfolio</a>
                    </li>
                    <li>
                      <a href="contact.html">Contact Us</a>
                    </li>
                    <li>
                      <a href="team.html">Team</a>
                    </li>
                  </ul>
                </div>
                <div className="menu-3">
                  <h3 className="widget-title-link-wrap">Contact</h3>
                  <ul className="widget-list-contact text-white link-style-2">
                    <li>
                      <a
                        href="tel:012345678"
                        className="meta-phone section-16px-regular-montserrat"
                      >
                        +7 (928)-111-23-456
                      </a>
                    </li>
                    <li>
                      <a
                        href="mailto:example@Pionners-solutions"
                        className="meta-mail section-16px-regular-montserrat"
                      >
                        Pionners-solutions
                      </a>
                    </li>
                    <li>
                      <h3 className="meta-address section-16px-regular-montserrat">
                        374 William S Canning Blvd,
                      </h3>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>

      <div id="bottom" className="clearfix has-spacer">
        <div id="bottom-bar-inner" className="container">
          <div className="bottom-bar-inner-wrap">
            <div className="bottom-bar-content">
              <div id="copyright">
                © 2025{" "}
                <span className="text">
                  Pioneers-solution , All Rights Reserved.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Footer;
